/**
* PORT-2
* Поправить отображение длинных строк в таблице
* Блок: Контент документации
* Раздел: Документация
* Поправить отображение длинных строк в таблице
**/
import "./table_responsive.css"
$(document).ready(function () {
    $("table").wrap("<div class='table_response'></div>");
});